import { Link } from 'react-router-dom';

export default function Footer() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer className="bg-[#0A1628] text-white">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-6 py-20">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Column 1 - Brand */}
          <div>
            <img
              src="https://static.readdy.ai/image/d6b4b88b420755e3ba36fdd8ab8e8672/43b1a7a9dc913fdbd622cad5f4bf97fa.png"
              alt="Tri County Ninja"
              className="h-16 w-auto mb-4"
            />
            <p className="text-white/70 mb-6">Train Like a Ninja</p>

            {/* Social Icons */}
            <div className="flex space-x-3">
              <a
                href="https://www.instagram.com/tricountyninja/"
                className="w-10 h-10 bg-[#FF6B35] rounded-full flex items-center justify-center hover:scale-110 hover:rotate-6 transition-all duration-300 cursor-pointer"
              >
                <i className="ri-instagram-line text-white text-xl"></i>
              </a>
              <a
                href="https://www.facebook.com/tricountyninja"
                className="w-10 h-10 bg-[#FF6B35] rounded-full flex items-center justify-center hover:scale-110 hover:rotate-6 transition-all duration-300 cursor-pointer"
              >
                <i className="ri-facebook-fill text-white text-xl"></i>
              </a>
            </div>
          </div>

          {/* Column 2 - Quick Links */}
          <div>
            <h4 className="text-[#FF6B35] text-sm font-bold uppercase tracking-wider mb-6">
              Quick Links
            </h4>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection("home")}
                  className="text-white/80 hover:text-[#FF6B35] transition-colors duration-300 flex items-center group cursor-pointer"
                >
                  Home
                  <i className="ri-arrow-right-line ml-2 opacity-0 group-hover:opacity-100 transition-opacity"></i>
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection("schedule")}
                  className="text-white/80 hover:text-[#FF6B35] transition-colors duration-300 flex items-center group cursor-pointer"
                >
                  Schedule
                  <i className="ri-arrow-right-line ml-2 opacity-0 group-hover:opacity-100 transition-opacity"></i>
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection("pricing")}
                  className="text-white/80 hover:text-[#FF6B35] transition-colors duration-300 flex items-center group cursor-pointer"
                >
                  Pricing
                  <i className="ri-arrow-right-line ml-2 opacity-0 group-hover:opacity-100 transition-opacity"></i>
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection("programs")}
                  className="text-white/80 hover:text-[#FF6B35] transition-colors duration-300 flex items-center group cursor-pointer"
                >
                  Memberships
                  <i className="ri-arrow-right-line ml-2 opacity-0 group-hover:opacity-100 transition-opacity"></i>
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection("programs")}
                  className="text-white/80 hover:text-[#FF6B35] transition-colors duration-300 flex items-center group cursor-pointer"
                >
                  Open Gym
                  <i className="ri-arrow-right-line ml-2 opacity-0 group-hover:opacity-100 transition-opacity"></i>
                </button>
              </li>
            </ul>
          </div>

          {/* Column 3 - Programs */}
          <div>
            <h4 className="text-[#FF6B35] text-sm font-bold uppercase tracking-wider mb-6">
              Programs
            </h4>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection("programs")}
                  className="text-white/80 hover:text-[#FF6B35] transition-colors duration-300 flex items-center group cursor-pointer"
                >
                  Kids Classes
                  <i className="ri-arrow-right-line ml-2 opacity-0 group-hover:opacity-100 transition-opacity"></i>
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection("programs")}
                  className="text-white/80 hover:text-[#FF6B35] transition-colors duration-300 flex items-center group cursor-pointer"
                >
                  Teen Training
                  <i className="ri-arrow-right-line ml-2 opacity-0 group-hover:opacity-100 transition-opacity"></i>
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection("programs")}
                  className="text-white/80 hover:text-[#FF6B35] transition-colors duration-300 flex items-center group cursor-pointer"
                >
                  Adult Training
                  <i className="ri-arrow-right-line ml-2 opacity-0 group-hover:opacity-100 transition-opacity"></i>
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection("programs")}
                  className="text-white/80 hover:text-[#FF6B35] transition-colors duration-300 flex items-center group cursor-pointer"
                >
                  Drop‑In
                  <i className="ri-arrow-right-line ml-2 opacity-0 group-hover:opacity-100 transition-opacity"></i>
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection("events")}
                  className="text-white/80 hover:text-[#FF6B35] transition-colors duration-300 flex items-center group cursor-pointer"
                >
                  Events
                  <i className="ri-arrow-right-line ml-2 opacity-0 group-hover:opacity-100 transition-opacity"></i>
                </button>
              </li>
            </ul>
          </div>

          {/* Column 4 - Contact */}
          <div>
            <h4 className="text-[#FF6B35] text-sm font-bold uppercase tracking-wider mb-6">
              Contact
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start">
                <i className="ri-phone-line text-[#FF6B35] text-lg mt-1 mr-3"></i>
                <span className="text-white/80 text-sm">(810) 354‑8352</span>
              </li>
              <li className="flex items-start">
                <i className="ri-mail-line text-[#FF6B35] text-lg mt-1 mr-3"></i>
                <span className="text-white/80 text-sm">staff@tricountyninja.com</span>
              </li>
              <li className="flex items-start">
                <i className="ri-map-pin-line text-[#FF6B35] text-lg mt-1 mr-3"></i>
                <span className="text-white/80 text-sm">
                  14283 Fenton Rd <br />
                  Fenton, MI 48430
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Divider */}
      <div className="max-w-7xl mx-auto px-6">
        <div className="h-px bg-white/15"></div>
      </div>

      {/* Bottom Bar */}
      <div className="max-w-7xl mx-auto px-6 py-8">
        <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <p className="text-gray-400 text-sm">© 2018 Tri County Ninja. All rights reserved.</p>
          <div className="flex space-x-6 text-sm">
            <Link
              to="/privacy-policy"
              className="text-gray-400 hover:text-[#FF6B35] transition-colors cursor-pointer whitespace-nowrap"
            >
              Privacy Policy
            </Link>
            <span className="text-gray-600">|</span>
            <Link
              to="/terms-of-service"
              className="text-gray-400 hover:text-[#FF6B35] transition-colors cursor-pointer whitespace-nowrap"
            >
              Terms of Service
            </Link>
            <span className="text-gray-600">|</span>
            <a
              href="#"
              className="text-gray-400 hover:text-[#FF6B35] transition-colors cursor-pointer whitespace-nowrap"
            >
              Waiver
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}